﻿export type ResultatValg = ResultatValgVisning;

export interface ResultatValgVisning {
    visBoksB: boolean;
}

export const SET_VISNING = 'SET_VISNING';

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction;
